import Vue from "vue";
import Router from "vue-router";
// import Layout from "@views/layout";
Vue.use(Router);
import Layout from "@views/layout";

import zhRouter from "./modules/zh"; //中文
import enRouter from "./modules/en";

// 获取当前站点信息
let currentLanguage = ''; // 假设当前语言是中文
let Language = localStorage.getItem('currentLanguage');  //获取本地语言

import { getCurrSiteData } from "@api/home";

getCurrSiteDatas();
async function getCurrSiteDatas() {

  if (Language) {
    currentLanguage = Language;
  } else {
    let res = await getCurrSiteData({ 'isapi': 1 });
    if (res.status == 200) {
      if (res.data.apply_site != 'protal') {
        window.location.href = "/";
        // 获取当前ip站点信息
        const result = res.data.apply_site.split('_')[1]; // 通过下划线分割并获取第二部分
        currentLanguage = result;
      } else {
        currentLanguage = 'zh';
      }
      localStorage.setItem('currentLanguage', currentLanguage);
    }
  }
  localStorage.setItem('currentLanguage', currentLanguage);
}

// if (IsWap()) {

//   window.location.href = "/h5/index/index"
// }

// function IsWap() {
//   //获取浏览器navigator对象的userAgent属性（浏览器用于HTTP请求的用户代理头的值）
//   var info = navigator.userAgent;
//   //通过正则表达式的test方法判断是否包含“Mobile”字符串
//   var isPhone = /mobile/i.test(info);
//   //如果包含“Mobile”（是手机设备）则返回true
//   return isPhone
// }

export const constantRoutes = [

  {
    path: "/404",
    name: '404',
    hidden: true,
    component: () => import("@views/error/404"),
  },

  {
    path: "/401",
    name: '401',
    hidden: true,
    component: () => import("@views/error/401"),
  },

  // 中文 路由
  // zhRouter,
  // 英文路由
  // enRouter

  // 活动 active

  ...(currentLanguage == 'en' ? enRouter : zhRouter),

];

/**
 * 动态路由
 * 需要根据用户角色动态加载的路由
 */
export const asyncRoutes = [
  /**
   * 路由模块  
   **/
  ...(currentLanguage == 'en' ? enRouter : zhRouter),

  // 所有页面都未匹配到时
  // { path: "*", hidden: true, redirect: { path: '/' }, },

];

const createRouter = () =>
  new Router({
    mode: 'history', // 需要服务器支持
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// 在路由守卫中更新标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});



// 详情见: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // 重置路由器
}

export default router;
